// extracted by mini-css-extract-plugin
export default {"dash":"ErrorValidationList_dash__EhxiP"};